module.exports = __webpack_public_path__ + "static/developments-poster-bca8e8952bc76a33f684b1d641fa7fb4.png";